import { Component, Input, ElementRef, EventEmitter, Output, OnInit, forwardRef, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../core';
import { GrupoClassificacaoSituacao, getSituacao, grupoClassificacaoSituacaoAtivo, grupoClassificacaoSituacaoInativo } from '../grupo-classificacao-situacao';

@Component({
    selector: 'sgt-grupo-classificacao-situacao-select',
    templateUrl: './grupo-classificacao-situacao-select.component.html',
    styleUrls: ['./grupo-classificacao-situacao-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => GrupoClassificacaoSituacaoSelectComponent), multi: true },
    ]
})
export class GrupoClassificacaoSituacaoSelectComponent implements OnInit, OnChanges {
    situacoes: GrupoClassificacaoSituacao[];

    /** Situação selecionada */
    @Input() ngModel: number;
    /** Ao alterar situação selecionada */
    @Output() ngModelChange = new EventEmitter<number>();

    situacao: GrupoClassificacaoSituacao;

    /**
     * Nome do input
     */
    @Input() name: string;
    /**
     * ID do input
     */
    @Input() id: string;
    /**
     * Se o valor é obrigatório
     */
    @Input() required: any;
    /**
     * Se deve desabilitar o input
     */
    @Input() disabled: any;

    /** Se deve exibir a opção de Nenhuma Situação */
    @Input() isShowNenhumaSituacao = true;

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    constructor(private messageService: MessageService) { }

    ngOnInit() {
        this.situacoes = [grupoClassificacaoSituacaoAtivo, grupoClassificacaoSituacaoInativo];
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'ngModel') {
                this.situacao = getSituacao(this.ngModel);
            }
        }
    }

    /** Ao alterar a situação */
    onChange(value: number) {
        this.ngModel = value;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
